/*------------------------------------*\
    MODULES
\*------------------------------------*/
import ClipboardJS from "clipboard";

/*------------------------------------*\
    COPY TO CLIPBOARD
\*------------------------------------*/
class CopyToClipboard {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.originalText = self.elem.getAttribute('data-original-text');
        self.activeText = self.elem.getAttribute('data-active-text');
    }

    init() {
        let self = this;

        const clipboard = new ClipboardJS(self.elem);

        clipboard.on('success', function (evt) {
            self.elem.textContent = self.activeText;

            evt.clearSelection();

            setTimeout(() => {
                self.elem.textContent = self.originalText;
            }, 2000);
        });
    }
}

export default CopyToClipboard;
